import styles from 'styles/add/SubmitButton.module.css'

const SubmitButton = ({ children, teal, style }) => {
    return (
        <button
            type="submit"
            className={styles[teal?'teal':'btn']}
            style={style}>{children}</button>
    )
}

export default SubmitButton
